import React from "react";
import { useAssetsEntryModel } from "../assetsEntryModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useOrgModel } from '@/views/base/organization/orgModel'



export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useAssetsEntryModel();
    const { getOrgTreeSelect } = useOrgModel(() => [])
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "采购单号",
            fieldName: "code",
            span:4
        }, {
            type: SearchTypeEnum.Input,
            placeholder: "采购人员",
            fieldName: "createUser",
            span:4
        }, {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "申请部门",
            fieldName: "department",
            span:4,
            treeData: getOrgTreeSelect(DictCodeEnmu.ORG)
        }, {
            type: SearchTypeEnum.Input,
            placeholder: "供应商名称",
            fieldName: "supplierName",
            span:4
        },  {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["采购起始日期", "采购结束日期"],
            format: "YYYY-MM-DD",
            alloc: true,
            span:4
        }, 
    ]

    return (
        <YhPageHeader
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}